module.exports = __webpack_public_path__ + "static/img/vip-tan-top@2x.6063d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-tan-top@2x.png
// module id = T7Tj
// module chunks = 1